import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'tdesign-react';
import SvgIcon from '../SvgIcon';

/**
 * 通用tip控件
 * @param {Object} props
 * @param {*} props.children
 * @param {*} props.content 提示信息
 * @param {('big')} [props.size] 大小 big
 * @param {('left'|'right')} [props.align] 布局
 * @returns
 */
export default function Tip({ children, content, size, align, ...others }) {
  const big = size === 'big';
  return (
    <Root className='tip' big={big} align={align} {...others}>
      {children}
      {content && (
        <Tooltip
          overlayInnerStyle={{ maxWidth: 600 }}
          theme='light'
          content={<ToolTipContent>{content}</ToolTipContent>}
        >
          <div>
            <Icon $big={big} type='exclamation-circle' />
          </div>
        </Tooltip>
      )}
    </Root>
  );
}

const Root = styled.div`
  display: inline-flex;
  align-items: center;
  ${(props) => (props.align === 'right' ? 'justify-content: flex-end' : '')};
  ${(props) => props.big && `font-size: 22px;font-weight: 600;`}
`;

const ToolTipContent = styled.div`
  padding: 6px;
`;

const Icon = styled(SvgIcon)`
  color: var(--td-font-gray-2);
  cursor: pointer;
  margin-left: 4px;
  margin-top: -2px;
  ${(props) =>
    props.$big &&
    `
    width: 20px;
    height: 20px;
    margin-left: 6px;
  `}
`;
